import { ActivityReservationInternalModel } from "Services/API/API";
import { User } from "./type";

export const getActivitiesStates = (
   activities: ActivityReservationInternalModel[]
): string[] => {
   return Object.keys(
      activities.reduce((acc, activity) => {
         const state = activity.state;
         if (state) {
            acc[state] = true;
         }
         return acc;
      }, {})
   );
};

export const getMembersFromActivities = (
   activities: ActivityReservationInternalModel[]
): User[] => {
   const organizerMap: Record<string, User> = activities.reduce(
      (acc, activity) => {
         if (!acc[activity.memberId]) {
            acc[activity.memberId] = {
               id: activity.memberId,
               fullName: activity.memberFullName ?? "Unknown",
               email: activity.memberEmail,
            };
         }
         return acc;
      },
      {}
   );

   return Object.values(organizerMap);
};